import type { IconSvgObject } from './types';

const HousePlusIcon: IconSvgObject = [
  ["path", { d: "M17.995 15.5V21.5M21 18.495L15 18.495", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13 21.5H5C3.89543 21.5 3 20.6046 3 19.5V9.98834C3 9.3654 3.29026 8.77804 3.7851 8.39963L11.1028 2.80373C11.3604 2.60673 11.6757 2.5 12 2.5C12.3243 2.5 12.6396 2.60673 12.8972 2.80373L20.2149 8.39963C20.7097 8.77803 21 9.3654 21 9.98834V13.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M13 13.5H10C9.44772 13.5 9 13.9477 9 14.5V21.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default HousePlusIcon;
